import React, { FC, useState, useEffect, useMemo } from 'react';
import { RouteComponentProps, useParams } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { NOT_FOUND_ERROR_PAGE_PATH } from '../../../../../common/constants';
import {
  MdrtPassportBackgroundDetail,
  MdrtPassportBackgroundFormMode,
} from '../../../types/mdrt-passport-background-types';
import { fetchItem } from '../../../network/mdrtPassportBackgroundCrud';
import MdrtPassportBackgroundDetailForm from './components/MdrtPassportBackgroundDetailForm';
import { LayoutSplashScreen } from 'src/app/layout';

interface StateMdrtType {
  type: MdrtPassportBackgroundFormMode;
}

const MdrtPassportBackgroundDetailPage: FC<RouteComponentProps> = ({ history, location }) => {
  const { id } = useParams<{ id: string }>();
  const { formMode, itemId } = useMemo(() => {
    const state = location.state as StateMdrtType;
    return {
      formMode: state.type,
      itemId: id ? id : undefined,
    };
  }, [id, location]);

  const dispatch = useDispatch();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [itemDetail, setItemDetail] = useState<MdrtPassportBackgroundDetail>();

  const reloadData = () => {
    if (itemId) {
      setIsLoading(true);
      fetchItem(itemId, dispatch)
        .then((result) => {
          setItemDetail({ ...result, id: itemId });
        })
        .catch(() => {
          history.push(NOT_FOUND_ERROR_PAGE_PATH);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  useEffect(() => {
    reloadData();
    // eslint-disable-next-line
  }, [itemId]);

  return (
    <>
      {formMode === MdrtPassportBackgroundFormMode.CREATE && (
        <MdrtPassportBackgroundDetailForm
          formMode={formMode}
          onReload={reloadData}
          onRouteTo={(route) => history.push(route)}
        />
      )}
      {formMode !== MdrtPassportBackgroundFormMode.CREATE &&
        (isLoading || !itemDetail ? (
          <LayoutSplashScreen />
        ) : (
          <MdrtPassportBackgroundDetailForm
            itemId={itemId}
            formMode={formMode}
            itemDetail={itemDetail}
            onReload={reloadData}
            onRouteTo={(route) => history.push(route)}
          />
        ))}
    </>
  );
};

export default MdrtPassportBackgroundDetailPage;
